import { videos, type VideoItem } from '@/mocks/videos';

export const formatPlays = (plays: number): string => {
  if (plays >= 100000000) return `${(plays / 100000000).toFixed(1)}亿`;
  if (plays >= 10000) return `${(plays / 10000).toFixed(1)}万`;
  return `${plays}`;
};

export const getVideoById = (id: string): VideoItem | undefined =>
  videos.find((v) => v.id === id);

export const getVideosByCategory = (category: string): VideoItem[] =>
  videos.filter((v) => v.category === category);

export const getHotVideos = (count = 10): VideoItem[] =>
  [...videos].sort((a, b) => b.plays - a.plays).slice(0, count);

export const getLatestVideos = (count = 12): VideoItem[] =>
  [...videos].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, count);

export const getFeaturedVideos = (): VideoItem[] =>
  videos.filter((v) => v.featured);

export const getRelatedVideos = (video: VideoItem, count = 4): VideoItem[] =>
  videos
    .filter((v) => v.category === video.category && v.id !== video.id)
    .sort((a, b) => b.plays - a.plays)
    .slice(0, count);

export const searchVideos = (keyword: string): VideoItem[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return videos.filter(
    (v) =>
      v.title.toLowerCase().includes(kw) ||
      v.subtitle.toLowerCase().includes(kw) ||
      v.type.toLowerCase().includes(kw) ||
      v.region.toLowerCase().includes(kw) ||
      v.tags.some((t) => t.toLowerCase().includes(kw)),
  );
};

export const allYears: number[] = Array.from(
  new Set(videos.map((v) => v.year)),
).sort((a, b) => b - a);

export const allRegions: string[] = Array.from(
  new Set(videos.map((v) => v.region)),
);